/**
 * Every cache key in one place, so invalidation after a mutation is a
 * one-liner instead of a guess.
 */
export const queryKeys = {
  me: ['me'] as const,
  myLoot: ['me', 'loot'] as const,
  myGiveaways: ['me', 'giveaways'] as const,
  myMedias: ['me', 'medias'] as const,
  myGames: ['me', 'games'] as const,
  myPlatforms: ['me', 'external-platforms'] as const,

  giveaway: (id: string | number) => ['giveaway', String(id)] as const,
  giveawayEntrants: (id: number) => ['giveaway-entrants', id] as const,

  user: (username: string) => ['user', username] as const,
  usernameAvailable: (username: string) => ['auth', 'username-available', username] as const,
  userGiveaways: (username: string) => ['user', username, 'giveaways'] as const,
  giveawayCategory: (category: GiveawayCategory) => ['giveaway', 'category', category] as const,

  giveawayTypes: ['enums', 'giveaway-types'] as const,
  prizeTypes: ['enums', 'prize-types'] as const,
  objectives: ['enums', 'objectives'] as const,

  gameInfoAutocomplete: (query: string) => ['game-info', 'autocomplete', query] as const,
  gameInfoSearch: (query: string) => ['game-info', 'search', query] as const,

  managedGuilds: ['discord', 'guilds', 'managed'] as const,
} as const

export const GIVEAWAY_CATEGORIES = [
  'all',
  'new',
  'featured',
  'trending',
  'popular',
  'ending',
] as const
export type GiveawayCategory = (typeof GIVEAWAY_CATEGORIES)[number]
